import React from "react"
import "./_style.scss"

import { GatsbyImage, getImage } from "gatsby-plugin-image";
import TileProductReplacement from "§/src/components/atoms/content/tile-content-product-mini"

// Language
import { useTranslation } from 'react-i18next'

const RelatedProductsWithImage = ({ mainImage, products, ...props }) => {
  const { t } = useTranslation()

  // Preparazione sicura delle props
  const compClassName = "related-products-with-image"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName

  // Crea variabili con verifiche più rigide
  const mainImageData = mainImage ? getImage(mainImage) : null
  const hasProducts = Array.isArray(products) && products.length > 0
  const imageAltText = mainImage?.altText || ''

  return (
    <div comp={compClassName} className={compClass}>
      <div className="row">
        <div className="col-lg-12 col-xl-8">
          <div className="rounded-2">
            {mainImageData && (
              <GatsbyImage
                className="sw-image rounded-2 mb-4 mb-lg-0"
                image={mainImageData}
                objectFit="cover"
                alt={imageAltText}
              />
            )}
          </div>
        </div>
        <div className="col-lg-12 col-xl-4">
          {hasProducts && (
            <>
              <p className="fs-13 fw-semibold text-uppercase mb-2 mt-4 mt-xl-0">
                {t('Prodotti correlati')}
              </p>
              <TileProductReplacement data={products} />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default RelatedProductsWithImage
